export enum ProductName {
  DMEPOS_MA = 'dmepos',
  DMEPOS_MCD = 'dmepos-mcd',
  HH = 'hh',
  PAC_COM = 'pac-com',
  PAC_MA = 'pac-ma',
}
